module.exports = __webpack_public_path__ + "static/biennale-ultra-light-it-de4387ba5494e4fc77d6d47f0dda1932.otf";